<template>
    <div class="percentage-bar">
        <div
            class="clearfix percentage-bar__labels"
            v-if="labelA && labelB">
            <p class="percentage-bar__label float-left">
                {{ labelA }}: {{ percentageA | percent }}
            </p>
            <p class="percentage-bar__label float-right">
                {{ labelB }}: {{ percentageB | percent }}
            </p>
        </div>
        <div class="percentage-bar__container">
            <span
                class="percentage-bar__percentage percentage-bar__percentage--a"
                :style="{ width: (percentageA ? percentageA : 0) * 100 + '%' }"></span>
            <span
                class="percentage-bar__percentage percentage-bar__percentage--b"
                :style="{ width: (percentageB ? percentageB : 0) * 100 + '%' }"></span>
        </div>
    </div>
</template>

<style lang="scss">
    @import "../../styles/variables.scss";

    $bar-height: 10px;

    .percentage-bar {

        &__labels {
            margin-bottom: 10px;
        }

            &__label {
                margin: 0;
                font-weight: 700;
                color: #686F7B;
                font-size: 11px;
            }

        &__container {
            display: block;
            height: $bar-height;
            width: 100%;
            position: relative;
            border-radius: $bar-height;
            overflow: hidden;
            background-color: #f2f2f2;
        }

        &__percentage {
            position: absolute;
            height: $bar-height;
            -webkit-transition: all .25s ease;
               -moz-transition: all .25s ease;
                    transition: all .25s ease;
        }

        &__percentage--a {
            background: $light-blue;
            left: 0;
        }

        &__percentage--b {
            background: $success-color;
            right: 0;
        }
    }
</style>

<script>
    export default {
        name: 'percentage_bar',
        props: {
            labelA: {
                type: String,
                required: false,
                default: ''
            },
            labelB: {
                type: String,
                required: false,
                default: ''
            },
            percentageA: {
                type: Number,
                required: false,
                default: 0
            },
            percentageB: {
                type: Number,
                required: false,
                default: 0
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/general/PercentageBar.vue